import { triggerAuthDownload } from '@utils/authDownload';
import type { PreviewableAttachment } from './types';

const REVOKE_DELAY_MS = 60_000;

const saveBlob = (blob: Blob, filename: string): void => {
  const objectUrl = URL.createObjectURL(blob);
  const anchor = document.createElement('a');
  anchor.href = objectUrl;
  anchor.download = filename;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();
  // Revoking in the same tick races the browser's async download kick-off,
  // which truncates the file in some browsers.
  globalThis.setTimeout(() => URL.revokeObjectURL(objectUrl), REVOKE_DELAY_MS);
};

/** Save an attachment to disk, from local bytes when we still have them. */
export const downloadAttachment = async (item: PreviewableAttachment): Promise<void> => {
  if (!item.source) return;
  if (item.source.kind === 'local') {
    saveBlob(item.source.file, item.filename);
    return;
  }
  await triggerAuthDownload(item.source.url, item.filename);
};
